// Include translations.
require('./i18n');

// Default settings.
var month = 1;

// If a preselected date is specified
var preselectMonth = null;

//
var viewportWidth = window.outerWidth;

/*
|-------------------------------------------------------------------------
| Document ready.
|-------------------------------------------------------------------------
 */
$(document).ready(function () {
    function formatDateVanilla(date) {
        date = new Date(date);
        let formattedString = '';

        if (date.getUTCDate() < 10) {
            formattedString += '0' + date.getUTCDate() + '-';
        } else {
            formattedString += date.getUTCDate() + '-';
        }

        if ((date.getUTCMonth() + 1) < 10) {
            formattedString += '0' + (date.getUTCMonth() + 1) + '-';
        } else {
            formattedString += (date.getUTCMonth() + 1) + '-';
        }

        formattedString += date.getUTCFullYear();
        return formattedString;
    }


    $('#selectAccommodation').change(function () {
        $('.reset-dates').click();

        if ($(this).val() == '-1') {
            maxGuests = $('#selectAccommodation').data('guests_max_all');
            $('#guestsSelect strong').html(
                widgetI18n('maximal') +
                ' ' +
                maxGuests +
                ' ' +
                widgetI18n('persons-ex-babies')
            );
            if (widgetApp.guests > maxGuests) {
                widgetApp.changeAmountOfGuests(maxGuests, 0, 0, 0);
                $('.widget #guestsSelect #guests_young').val(0);
                $('.widget #guestsSelect #guests_child').val(0);
                $('.widget #guestsSelect #guests_baby').val(0);
                $('.widget #guestsSelect #guests_adult')
                    .val(maxGuests)
                    .change();
                alert(widgetI18n('note-guests-over-capacity'));
            }

            $('.calendars').html(
                '<img alt="empty" src="/img/empty.png" style="width: 300px; height: 200px; margin: auto;">'
            );
        } else {
            maxGuests = $(this).find(':selected').data('guests_max');
            $('#guestsSelect strong').html(
                widgetI18n('maximal', 'ucfirst') +
                ' ' +
                maxGuests +
                ' ' +
                widgetI18n('persons-ex-babies')
            );
            if (widgetApp.guests > maxGuests) {
                widgetApp.changeAmountOfGuests(maxGuests, 0, 0, 0);
                $('.widget #guestsSelect #guests_young').val(0);
                $('.widget #guestsSelect #guests_child').val(0);
                $('.widget #guestsSelect #guests_baby').val(0);
                $('.widget #guestsSelect #guests_adult')
                    .val(maxGuests)
                    .change();
                alert(widgetI18n('note-guests-over-capacity'));
            }

            $('.calendars').html(
                '<div className="text-center calendar-loader mb-sm-2">' +
                '<div ' +
                'class="spinner-border save-loading" ' +
                'style="' +
                'display: block; position: absolute; top: 50%; left: 50%; margin-top: -1.25rem; margin-left: -1.25rem; ' +
                'width: 2.5rem; height: 2.5rem; border: 0.2em solid #000; border-right-color: transparent;' +
                '"' +
                '>' +
                '</div>' +
                '</div>'
            );

            var result = $(this).val().split('/');
            accommodationType = $(this).find(':selected').data('type');
            accommodationNumber = result[4];
            widgetApp.accommodationType = accommodationType;
            widgetApp.accommodationNumber = result[4];
            widgetApp.accommodationEncryptedId = $(this).find(':selected').data('encrypted_id');
            $.get($(this).val(), function (data) {
                $('.calendars').html($(data).find('.calendars').html());
                $('section.question').html($(data).find('section.question').html());
                $(window).trigger('va-widget-loaded');
                widgetApp.calendars = $('.calendar-month');
                widgetApp.calendars.find('.day');
                widgetApp.selectMonthInput = $('.calendar-month-select');
            });
        }
    });

    /**
     * Provide website with feedback about the current height.
     */
    $('#tooltipTotalButton').hover(function (e) {
        $('#tooltipTotal').css('display', 'block');
        $('#tooltipTotal').css('margin-left', (e.pageX - 305))
            .css('top', e.pageY - ($('#tooltipTotal').outerHeight() + 5));
    }, function (e) {
        $('#tooltipTotal').css('display', 'none');
    });


    /*
     |-------------------------------------------------------------------------
     | App model object
     |--------------------------------------------------------------------------
     */
    var widgetApp = (function (app) {
        // Public
        app.window = $('window');
        app.guestFields = $('#guests,#guestsPopover');
        app.selectMonthInput = $('.calendar-month-select');
        // app.prevMonthButton = $('.widget #prev-month');
        app.prevMonthButton = $('.widget .nav-month-btn-prev');
        // app.nextMonthButton = $('.widget #next-month');
        app.nextMonthButton = $('.widget .nav-month-btn-next');
        app.calendars = $('.calendar-month');
        app.months = app.calendars.filter(function (index) {
            return $(this).closest('.widget-copy').length === 0;
        })
        app.startDay = $('.calendar-month .start-day');
        app.days = app.calendars.find('.day');
        app.accommodationType = accommodationType;
        app.accommodationEncryptedId = accommodationEncryptedId;
        app.accommodationNumber = accommodationNumber;
        app.virtualId = parseInt($('#virtualId').val());
        app.adults = 0;
        app.youngsters = 0;
        app.children = 0;
        app.babies = 0;
        app.guests = 1;
        app.startAt = null;
        app.endAt = null;
        app.widgetUUID = widgetId;
        app.contactName = $('.book-button').first().data('contact') !== undefined
            ? $('.book-button').first().data('contact')
            : '';

        // Private
        var periodStart = false;
        var periodEnd = false;

        /**
         * Changes the amount of guests and updates the corresponding fields.
         */
        app.changeAmountOfGuests = function (adults, youngsters, children, babies) {
            if (isNaN(adults) || isNaN(youngsters) || isNaN(children) || isNaN(babies)) {
                return;
            }

            app.adults = parseInt(adults);
            app.youngsters = parseInt(youngsters);
            app.children = parseInt(children);
            app.babies = parseInt(babies);
            app.guests = app.adults + app.youngsters + app.children + app.babies;

            app.trigger('guests.change');
        };

        /**
         * Moves one month backward in the calendars (if more months are available).
         */
        app.prevMonth = function () {
            app.months = app.calendars.filter(function (index) {
                return $(this).closest('.widget-copy').length === 0;
            });

            if (month > 1) {
                month--;
                app.trigger('month.change', [month]);
                $('.calendar-month-select').val(month);
            }
        };

        /**
         * Moves one month forward in the calendars (if more months are available).
         */
        app.nextMonth = function () {
            $('#minNights').css('display', 'none');
            $('#reservedDay').css('display', 'none');
            $('#availableDay').css('display', 'none');

            app.months = app.calendars.filter(function (index) {
                return $(this).closest('.widget-copy').length === 0;
            });

            if (month < app.months.length) {
                month++;
                app.trigger('month.change', [month]);
                $('.calendar-month-select').val(month);
            }
        };

        /*
         | Select a day as starting or end point of a holiday.
         */
        app.selectDay = function (day) {
            if (periodStart !== false && periodEnd !== false) {
                app.cancelSelection();
                return;
            }

            // Start of a new selection.
            if (periodStart === false && periodEnd === false) {

                // For usage in website.
                if ($('.price-block .product-info .included').length) {
                    $('.price-block .product-info .included p').html(widgetI18n('select-accommodation'));
                }

                if ($('.price-block .product-info .excluded').length) {
                    $('.price-block .product-info .excluded small').html(widgetI18n('select-accommodation'));
                }

                if (day.hasClass('reserved') && !day.hasClass('start-day') && !day.hasClass('first-day')) {
                    app.trigger('reserved.tooltip', [day.attr('data-date')]);
                } else if (day.hasClass('first-day') && !day.hasClass('start-day')) {
                    app.trigger('partlyAvailable.tooltip', [day.attr('data-date')]);
                } else if (day.hasClass('available') && !day.hasClass('start-day')) {
                    app.trigger('available.tooltip', [day.attr('data-date')]);
                }


                if (!day.hasClass('start-day')) {
                    return;
                }

                $('.day').removeClass('selection_start')
                    .removeClass('selection_end')
                    .removeClass('selection')
                    .removeClass('selected')
                    .removeClass('stayable')
                    .removeClass('deselected');

                periodStart = parseInt(day.attr('data-day_count'));
                app.startAt = day.attr('data-date');

                $('#holidayEndAt').html('Kies een vertrekdag.');

                app.trigger('startAt.change', [app.startAt]);
            } else {
                if (periodEnd === false && day.attr('data-day_count') > periodStart && day.hasClass('end-day')) {
                    var startEndAmount = $('.day.selection_end').attr('data-day_count') - $('.day.selection.selection_start').attr('data-day_count');

                    if (startEndAmount > 0) {
                        alert(widgetI18n('holiday-not-possible'));
                        app.cancelSelection();
                        return;
                    }

                    periodEnd = parseInt($(this).attr('data-day_count'));
                    app.endAt = day.attr('data-date');

                    app.trigger('endAt.change', [app.endAt]);
                }
            }
        };

        /*
         | Cancel holiday selection.
         */
        app.cancelSelection = function (keepHolidays = false) {
            periodStart = false;
            periodEnd = false;

            $('.day').removeClass('deselected')
                .removeClass('end-day');

            $('#minNights').css('display', 'none');
            $('#reservedDay').css('display', 'none');
            $('#availableDay').css('display', 'none');

            if (!keepHolidays) {
                $('.day').removeClass('selection_start')
                    .removeClass('selection_end')
                    .removeClass('selection')
                    .removeClass('selected')
                    .removeClass('stayable')
                    .removeClass('deselected');

                $('.price, .discount').css('display', 'none');
                $('#price-per-person').html('');
                $('.book-button').addClass('disabled');
                $('.book-button').html(widgetI18n('choose-arrival'));
                $('.option-button').attr('href', '#this');
                $('#holidayStartAt').html(widgetI18n('choose-arrival') + '.');
                $('#holidayEndAt').html('');

                app.trigger('selection.canceled', [app.endAt]);
            }
        };

        /*
         | Hover calendar days.
         */
        app.hoverDay = function (day) {
            if (periodStart !== false && periodStart >= 0 && periodEnd === false && parseInt(day.attr('data-day_count')) > periodStart) {
                $('.day').removeClass('selection');
                for (var i = periodStart; i <= parseInt(day.attr('data-day_count')); i++) {
                    $('.day[data-day_count="' + i + '"]').addClass('selection');
                }
            }
        };

        /*
         * Requests pricing details for the currently selected holiday.
         *
         * @param callback
         */
        app.getPrice = function () {
            if (app.guests > 0 && app.startAt != null && app.endAt != null) {
                if ($('section.dates').css('display') === 'block' && $(window).width() < 767) {
                    $('section.calendars').css('display', 'none');
                    $('section.legend').css('display', 'none');

                    // Provide website with feedback about the current height.
                    messageWidgetHeight();
                }

                $('.price,.discount').css('display', 'none');
                $('.price-loader').css('display', 'block');

                var startAt = app.startAt.substr(6, 4) +
                    '-' + app.startAt.substr(3, 2) +
                    '-' + app.startAt.substr(0, 2)
                var endAt = app.endAt.substr(6, 4) +
                    '-' + app.endAt.substr(3, 2) +
                    '-' + app.endAt.substr(0, 2)
                let lang = $('html').attr('lang') === undefined ? 'nl' : $('html').attr('lang');

                if ((app.adults + app.youngsters + app.children + app.babies) > 0) {
                    $.post(apiEndpoint + '/search?lang=' + lang, {
                        _method: 'POST',
                        start_at: startAt,
                        end_at: endAt,
                        adult: app.adults,
                        youngster: app.youngsters,
                        child: app.children,
                        baby: app.babies,
                        accommodation_numbers: "[" + widgetApp.accommodationNumber + "]",
                        cache: 0,
                        cheapest_stay: 0,
                        owner_id: null
                    }).done(function (result) {
                        app.trigger('price.change', result);
                    }).fail(function (result) {
                        if (result.responseJSON.message === 'Provided slot is unavailable') {
                            $(window).trigger('va-widget.already-booked', result);
                            $('.already-booked').removeClass('d-none');
                            $('.price-loader').css('display', 'none');
                        }
                    });
                }
            }
        };

        return app;
    })($({}));

    /*
     |--------------------------------------------------------------------------
     | Global event listeners
     |--------------------------------------------------------------------------
     */
    $(window)
        .on('va-widget.guests.change', function (e, adults, youngsters, children, babies) {
            widgetApp.changeAmountOfGuests(adults, youngsters, children, babies);
        });
    $(window)
        .on('va-widget-loaded', function (e) {
            updateCalendars(month);
        });

    /*
     |--------------------------------------------------------------------------
     | App event listeners
     |--------------------------------------------------------------------------
     */
    widgetApp
        .on('guests.change', function (e) {
            updateGuestsAmount();
            widgetApp.getPrice();
        })

        .on('price.change', function (e, data) {
            if (data == 'false') {
                alert(widgetI18n('no-holiday'));
                widgetApp.cancelSelection();
                return;
            }

            let lang = $('html').attr('lang') === undefined ? 'nl' : $('html').attr('lang');
            let website_id = $('body').data('website_id');
            let page_id = $('body').data('page_id');
            let page_type = $('body').data('page_type');

            var stay = data.data[0];

            stay['book_url'] = stay['book_url'].replace('--widgetUUID--', widgetId);
            stay['book_option_url'] = stay['book_option_url'].replace('--widgetUUID--', widgetId);

            data.data[0]['book_url'] = data.data[0]['book_url'] + '?booking_type=booking-request&lang=' + lang + '&website_id=' + website_id + '&page_id=' + page_id + '&page_type=' + page_type;
            data.data[0]['book_option_url'] = data.data[0]['book_option_url'] + '&booking_type=option-request&lang=' + lang + '&website_id=' + website_id + '&page_id=' + page_id + '&page_type=' + page_type;
            $(window).trigger('va-widget.price.change', [data, widgetId]);

            widgetApp.cancelSelection(true);

            updatePrice(stay);
            updateReservationButtons(stay.has_option);
            updateTimes(stay.stay.start_at.substr(11, 5), stay.stay.end_at.substr(11, 5));
            var includedCostsString = updateIncludedCosts(stay.stay.included_costs, stay.stay.required_costs_stay_details, stay.stay.required_costs_person_details);
            var optionalCostsStringDeposit = updateOptionalCosts(stay.stay.optional_costs, stay.stay.deposit_costs, true);
            var optionalCostsString = updateOptionalCosts(stay.stay.optional_costs, stay.stay.deposit_costs, false);
            $('#optional').html(optionalCostsString);
            if (optionalCostsString === '') {
                $('.optional h5').css('display', 'none');
            } else {
                $('.optional h5').css('display', 'block');
            }

            // // For usage in website.
            // if ($('.price-block .product-info .included').length) {
            //     $('.price-block .product-info .included p').html(includedCostsString);
            // }
            //
            // if ($('.price-block .product-info .excluded').length) {
            //     $('.price-block .product-info .excluded small').html(optionalCostsStringDeposit);
            // }

            updateTotalPriceTooltip($('#included').html(), optionalCostsStringDeposit);
            widgetApp.find('.stayable').removeClass('stayable');

            messageWidgetHeight();
        })

        .on('month.change', function (e, data) {
            updateCalendars(data);
        })

        .on('startAt.change', function (e, data) {
            updateStartAt(data);
        })

        .on('reserved.tooltip', function (e, data) {
            showTooltipReserved(data);
        })

        .on('available.tooltip', function (e, data) {
            showTooltipAvailableNoStartDay(data);
        })

        .on('partlyAvailable.tooltip', function (e, data) {
            showTooltipAvailablePartly(data);
        })


        .on('endAt.change', function (e, data) {
            updateEndAt(data);

            if (window.location !== window.parent.location) {
                // The page is in an iframe
                $("html, body").animate({scrollTop: $(document).height()}, "slow");
            }

            widgetApp.getPrice();
        })

        .on('selection.canceled', function (e, data) {
            $('#included').html(widgetI18n('select-holiday'));
            $('#optional').html('');
            $('.price-loader').css('display', 'none');
            $('.book-button').attr('href', '#this')
                .addClass('disabled');
            $('.book-button').html(widgetI18n('choose-arrival'));
            $('.option-button').attr('href', '#this');
        });

    /*
     |--------------------------------------------------------------------------
     | DOM event listeners
     |--------------------------------------------------------------------------
     */
    widgetApp.window.resize(function () {
        updateCalendars(1);
    });

    widgetApp.guestFields.change(function () {
        widgetApp.changeAmountOfGuests(widgetApp.guestFields.val());
    });

    $('body').on('change', '.calendar-month-select', function () {
        month = $(this).val();
        $('.calendar-month-select').val(month);
        updateCalendars(month);
    });

    // $('body').on('click', '.widget #next-month', function () {
    $('body').on('click', '.widget .nav-month-btn-next', function () {
        widgetApp.nextMonth();
    });

    // $('body').on('click', '.widget #prev-month', function () {
    $('body').on('click', '.widget .nav-month-btn-prev', function () {
        widgetApp.prevMonth();
    });

    $('body').on('click', '.widget .calendars .day', function () {
        widgetApp.selectDay($(this));
    });

    $('body').on('mouseover', '.widget .calendars .day', function () {
        if (!$(this).hasClass('deselected')) {
            widgetApp.hoverDay($(this));
        } else {
            $('.day').removeClass('selection');
        }
    });

    /*
     |--------------------------------------------------------------------------
     | Initialize guests
     |--------------------------------------------------------------------------
     */
    if (maxGuests >= (adults + youngsters + children) && 0 < (adults + youngsters + children)) {
        if (adults !== 0) {
            $('#guests_adult').find('option[value="' + adults + '"]').prop('selected', true);
            updateGuestsString($('#guests_adult'))
        }
        if (youngsters !== 0) {
            $('#guests_young').find('option[value="' + youngsters + '"]').prop('selected', true);
            updateGuestsString($('#guests_young'))
        }
        if (children !== 0) {
            $('#guests_child').find('option[value="' + children + '"]').prop('selected', true);
            updateGuestsString($('#guests_child'))
        }
    } else {
        adults = 1;
        youngsters = 0;
        children = 0;
        widgetApp.adults = adults;
        widgetApp.youngsters = youngsters;
        widgetApp.children = children;
        widgetApp.guests = 1;
    }

    if (babies !== 0 && babies < 6) {
        $('#guests_baby').find('option[value="' + babies + '"]').prop('selected', true);
        updateGuestsString($('#guests_baby'));
    } else {
        babies = 0;
        widgetApp.babies = babies;
    }

    /*
     |--------------------------------------------------------------------------
     | Select preselected stay.
     |--------------------------------------------------------------------------
     */
    if (preselectedStartAt !== false && preselectedEndAt !== false) {
        let preselect = widgetApp.days
            .filter('[data-date="' + formatDateVanilla(preselectedStartAt) + '"]')
            .first();


        // Move calendar to preselected month
        preselectMonth = preselect.closest('.calendar-month').attr('data-current-month-counter');
        preselectMonth = parseInt(preselectMonth);
        month = preselectMonth;
        $('.calendar-month-select').val(month);

        preselect
            .addClass('preselectedClick')
            .click();
    } else {
        $('.calendar-month').each(function () {
            if ($(this).find('.no-arrivals').length == 0) {
                preselectMonth = $(this).attr('data-current-month-counter');
                preselectMonth = parseInt(preselectMonth);
                month = preselectMonth;
                $('.calendar-month-select').val(month);

                return false;
            }
        });

        /** Open calendar on mobile if no preselected stay available*/
        if ($('section.calendars').width() <= 480) {
            setTimeout(() => {
                $('#startAt,#endAt').val('');
                $('.time-label').remove();
                widgetApp.cancelSelection();

                $('#startAt').addClass('inputSelected');
                $('#endAt').removeClass('inputSelected');
                $('#widget').removeClass('calendar-right').addClass('calendar-left');
                $('section.calendars').css('display', 'flex');
                updateCalendars(month);
            })
        }

        widgetApp.cancelSelection();
    }

    /*
     |--------------------------------------------------------------------------
     | Methods for updating the UI
     |--------------------------------------------------------------------------
     */

    /*
     * Display correct months based on the current position.
     */
    function updateCalendars(month) {
        var width = $('section.calendars').width();
        $('.calendar-month').css('display', 'none');
        $('.calendar-month').removeClass('one-calendar two-calendars three-calendars');

        if ($('#guestsSelect').css('display') == 'block') {
            $('#guestsSelect').css('left', $('#guestsTotal').offset().left);
            $('#guestsSelect').show();
        }

        if (width <= 480) {
            $('section.calendars').css('display', 'flex');
            $('section.legend').css('display', 'block');
            $('.current-month-counter-' + month).css('display', 'block');
            $('.calendar-month').addClass('one-calendar');
        } else if (width < 950) {
            $('section.calendars').css('display', 'flex');
            $('.current-month-counter-' + month).css('display', 'block');
            $('.current-month-counter-' + (month + 1)).css('display', 'block');
            $('.calendar-month').addClass('two-calendars');
        } else {
            $('section.calendars').css('display', 'flex');
            $('.current-month-counter-' + month).css('display', 'block');
            $('.current-month-counter-' + (month + 1)).css('display', 'block');
            $('.current-month-counter-' + (month + 2)).css('display', 'block');
            $('.calendar-month').addClass('three-calendars');
        }

        let dayWidth = $('.current-month-counter-' + month + ' .day').width();
        let dayHeight = dayWidth;
        if (dayHeight < 30) {
            dayHeight = 30;
        }
        $('.calendar-month .day').height(dayHeight)
            .css({'line-height': dayHeight + 'px'});

        // Provide website with feedback about the current height.
        messageWidgetHeight();
    }

    /*
     * Shows the price of the selected holiday and enabled the book button.
     */
    function updatePrice(stay) {
        let lang = $('html').attr('lang') === undefined ? 'nl' : $('html').attr('lang');
        let referer = $('#referer').data('referer');
        if (typeof stay == 'undefined') {
            $('.price').css('display', 'none');

            $('.book-button').attr('href', '#this')
                .addClass('disabled');
            $('.option-button').attr('href', '#this');
        } else {
            if (widgetApp.accommodationType == 'house') {
                $('.book-button').attr('href', '/bookings/houses/' + widgetApp.accommodationEncryptedId + '/' + widgetApp.adults + '/' + widgetApp.youngsters + '/' + widgetApp.children + '/' + widgetApp.babies + '/' + widgetApp.startAt + '/' + widgetApp.endAt + '/' + widgetApp.widgetUUID + '?referer=' + referer + '&lang=' + lang)
                    .removeClass('disabled');
                $('.option-button').attr('href', '/bookings/houses/' + widgetApp.accommodationEncryptedId + '/' + widgetApp.adults + '/' + widgetApp.youngsters + '/' + widgetApp.children + '/' + widgetApp.babies + '/' + widgetApp.startAt + '/' + widgetApp.endAt + '/' + widgetApp.widgetUUID + '?option=1&referer=' + referer + '&lang=' + lang);
                $('.book-button').html(widgetI18n('book-now') + (widgetApp.contactName.length ? ' ' + widgetI18n('with') + ' ' + widgetApp.contactName : ''));
            } else {
                $('.book-button').attr('href', '/bookings/virtuals/' + widgetApp.accommodationEncryptedId + '/' + widgetApp.adults + '/' + widgetApp.youngsters + '/' + widgetApp.children + '/' + widgetApp.babies + '/' + widgetApp.startAt + '/' + widgetApp.endAt + '/' + widgetApp.widgetUUID + '?referer=' + referer + '&lang=' + lang)
                    .removeClass('disabled');
                $('.option-button').attr('href', '/bookings/virtuals/' + widgetApp.accommodationEncryptedId + '/' + widgetApp.adults + '/' + widgetApp.youngsters + '/' + widgetApp.children + '/' + widgetApp.babies + '/' + widgetApp.startAt + '/' + widgetApp.endAt + '/' + widgetApp.widgetUUID + '?option=1&referer=' + referer + '&lang=' + lang);
                $('.book-button').html(widgetI18n('place-option') + ' <small>(' + widgetI18n('tip-read-explanation') + ')</small>');
            }

            // Show discount (if any and higher than the lastminute discount).
            if (stay.amount_without_discount > stay.amount) {
                $('.discount').html('<del style="color: #ccc;">' + formatMoney(stay.amount_without_discount) + '</del> -' + Math.round(100 - (stay.amount / stay.amount_without_discount) * 100) + '%');
                $('.discount').css('display', 'inline-block');
            }

            $('.price span').html(formatMoney(stay.amount)).css('display', 'inline-block');
            $('.price').css('display', 'block');

            var pricePerPerson = formatMoney(stay.amount / (widgetApp.adults + widgetApp.youngsters + widgetApp.children + widgetApp.babies));
            $('#price-per-person').html(widgetI18n('calculated') + '' + pricePerPerson + ' ' + widgetI18n('per-person'));

            $('#tooltipTotalButton').hover(function (e) {
                $('#tooltipTotal').css('display', 'block')
                    .css('top', e.pageY - ($('#tooltipTotal').outerHeight() + 5))
                    .css('width', 300);
                var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                if (viewportWidth < 483) {
                    $('#tooltipTotal').css('margin-left', 3).css('width', 'calc(100% - 6px)');
                } else if (viewportWidth < 769) {
                    $('#tooltipTotal').css('margin-left', (e.pageX));
                } else {
                    $('#tooltipTotal').css('margin-left', (e.pageX - 305));
                }
            }, function (e) {
                $('#tooltipTotal').css('display', 'none');
            });
        }

        $('.price-loader').css('display', 'none');
        $('.already-booked').addClass('d-none');
    }

    /**
     * @param hasOptions
     */
    function updateReservationButtons(hasOptions) {
        let btn = $('.book-button');
        btn.html(
            hasOptions
                ? widgetI18n('place-option') + ' <small>(' + widgetI18n('tip-read-explanation') + ')</small>'
                : widgetI18n('book-now') + (widgetApp.contactName.length ? ' ' + widgetI18n('with') + ' ' + widgetApp.contactName : '')
        );

        if (hasOptions) {
            $('#takeOption').hide();
            btn.attr('href', $('.option-button').attr('href'));
            $('section.option').css('display', 'none');
            $('.has-option-text').addClass('active');
        }
    }

    /**
     * Resorts default reservation button
     */
    function resortDefaultReservationButton() {
        var bookBtnHref = $('.book-button').attr('href');

        if (bookBtnHref !== undefined) {
            $('.book-button')
                .attr('href', bookBtnHref.replace('?option=1', ''))
                .text('Boek nu' + (widgetApp.contactName.length ? ' bij ' + widgetApp.contactName : ''));
        }

        $('section.option').css('display', 'initial');
        $('.has-option-text').removeClass('active');
        $('#takeOption').show();
    }

    /**
     * @param arrivalAt
     * @param departureAt
     */
    function updateTimes(arrivalAt, departureAt) {
        // Mobile
        $('.time-label').remove();
        $('#startAt').after('<span class="time-label d-block d-md-none" style="font-size:14px;">' +
            widgetI18n('from') + '  <b>' + arrivalAt.substr(0, 5) + ' ' +
            widgetI18n('hour-time') + '</b>' +
            '</span>');
        $('#endAt').after('<span class="time-label d-block d-md-none text-left" style="font-size:14px;">' +
            widgetI18n('untill') + '  <b>' + departureAt.substr(0, 5) + ' ' + widgetI18n('hour-time') + '</b>' +
            '</span>');

        if ($('#holidayStartAt').html() === undefined) {
            return;
        }

        let timeRegex = /\d{2}:\d{2}/gi
        if (!timeRegex.test($('#holidayStartAt').text()) === true) {
            $('#holidayStartAt').append(" / " + arrivalAt.substr(0, 5) + ' ' + widgetI18n('hour-time'));
        }

        /** Reset regex */
        timeRegex = /\d{2}:\d{2}/gi

        if (!timeRegex.test($('#holidayEndAt').text()) === true) {
            $('#holidayEndAt').append(" / " + departureAt.substr(0, 5) + ' ' + widgetI18n('hour-time'));
        }
    }

    /*
     * Show costs included with the selected holiday.
     */
    function updateIncludedCosts(includedCosts, requiredCostsStay, requiredCostsPerson) {
        var includedCostsString = '';
        $.each(includedCosts, function (i, cost) {
            includedCostsString = includedCostsString + cost['title'] + ', ';
        });

        $.each(requiredCostsStay, function (i, cost) {
            includedCostsString = includedCostsString + cost['title'] + ', '; // + ' (' + cost['amount']['stay'] + ' ' + cost['unit'] + '), ';
        });

        $.each(requiredCostsPerson, function (i, cost) {
            includedCostsString = includedCostsString + cost['title'] + ', '; // + ' (' + cost['amount']['stay'] + ' ' + cost['unit'] + '), ';
        });

        if (includedCostsString !== '') {
            includedCostsString = includedCostsString.substr(0, includedCostsString.length - 2);
        }

        $('#included').html(includedCostsString);

        return includedCostsString;
    }

    /*
     * Show optional costs with the selected holiday.
     */
    function updateOptionalCosts(optionalCosts, depositCosts, addDepositCosts) {
        var optionalCostsString = '';
        $.each(optionalCosts, function (i, cost) {
            optionalCostsString = optionalCostsString + cost['title'] + ', '; // + ' (' + cost['amount']['stay'] + ' ' + cost['unit'] + '), ';
        });

        var units = {
            per_person: widgetI18n('per-person'),
            per_person_per_night: widgetI18n('per-person-per-night'),
            per_stay: widgetI18n('per-stay'),
            per_night: widgetI18n('per-night'),
            per_unit: widgetI18n('per-unit'),
            per_package: widgetI18n('per-package'),
            percent_of_rent: widgetI18n('percent-of-rent'),
            per_m3: widgetI18n('per-m3'),
            per_kwh: widgetI18n('per-kwh')
        };

        if (addDepositCosts === true) {
            $.each(depositCosts, function (i, cost) {
                optionalCostsString = optionalCostsString + cost['title'] + ' (€' + cost['amount']['stay'] + ' ' + units[cost['unit']] + '), ';
            });
        }

        if (optionalCostsString != '') {
            optionalCostsString = optionalCostsString.substr(0, optionalCostsString.length - 2);
        }

        return optionalCostsString;
    }

    /**
     * @param includedCostsString
     * @param excludedCostsString
     */
    function updateTotalPriceTooltip(includedCostsString, excludedCostsString) {
        var tooltipTotalString = '<div class="row">' +
            '<div class="col-1 float-left">' +
            '<i class="far fa-check-circle" style="color: #54BE54;"></i>' +
            '</div>' +
            '<div class="col-10 float-left">' +
            '<strong>' + widgetI18n('price-including') + '</strong> ' +
            '(gebaseerd op ';

        // Determine guests string.
        var tooltipGuests = '';
        if (widgetApp.adults > 0) {
            tooltipGuests += widgetApp.adults + ' ' + widgetI18n('adults') + ', ';
        }
        if (widgetApp.youngsters > 0) {
            tooltipGuests += widgetApp.youngsters + ' ' + widgetI18n('youngsters') + ', ';
        }
        if (widgetApp.children > 0) {
            tooltipGuests += widgetApp.children + ' ' + widgetI18n('children') + ', ';
        }
        if (widgetApp.babies > 0) {
            tooltipGuests += widgetApp.babies + ' ' + widgetI18n('babies') + ', ';
        }
        tooltipTotalString += tooltipGuests.substr(0, tooltipGuests.length - 2) + ')';

        tooltipTotalString += '<br>' + includedCostsString + '</div>' +
            '</div>';

        // Excluding.
        if (excludedCostsString !== '') {
            tooltipTotalString += '<div class="row mt-2">' +
                '<div class="col-1">' +
                '<i class="far fa-times-circle" style="color: #ff0000;"></i>' +
                '</div>' +
                '<div class="col-10">' +
                '<strong>' + widgetI18n('price-excluding') + '</strong>' +
                '<br>' + excludedCostsString +
                '</div>';
        }

        $('#tooltipTotal').html(tooltipTotalString);
    }

    /*
     * Show the amount of selected guests near the holiday summery.
     */
    function updateGuestsAmount() {
        let guests = getGuestsTotal();
        var babies = parseInt(widgetApp.babies);

        var guestsString = (guests - babies);
        if ((guests - babies) > 1) {
            guestsString = guestsString + ' ' + widgetI18n('persons');
        } else {
            guestsString = guestsString + ' ' + widgetI18n('person');
        }

        if (babies > 0) {
            guestsString = guestsString + ' + ' + babies;
            if (babies > 1) {
                guestsString = guestsString + ' ' + widgetI18n('babies');
            } else {
                guestsString = guestsString + ' ' + widgetI18n('baby');
            }
        }

        $('#guestsTotal #guestsValue').html(guestsString);
        $('#bookingGuests').html(guestsString);
    }

    /**
     * @param date
     * @returns {null|string}
     */
    function getDayOfWeek(date) {
        let dateString = date.substr(6, 4) + '-' + date.substr(3, 2) + '-' + date.substr(0, 2);
        let dayOfWeek = new Date(dateString).getDay();
        return isNaN(dayOfWeek) ? null : ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'][dayOfWeek];
    }

    function showTooltipReserved(startAt) {
        $('#availableDay').css('display', 'none');

        var position = $('.day.reserved[data-date="' + startAt + '"]').offset();
        $('#reservedDay')
            .css('left', position.left)
            .css('top', position.top - 26)
            .css('display', 'block');
    }

    function showTooltipAvailableNoStartDay(startAt) {
        $('#reservedDay').css('display', 'none');

        var position = $('.day.available[data-date="' + startAt + '"]').offset();
        $('#availableDay').css('left', position.left)
            .css('top', position.top - 26)
            .css('display', 'block');
    }

    function showTooltipAvailablePartly(startAt) {
        $('#reservedDay').css('display', 'none');

        var position = $('.day.first-day[data-date="' + startAt + '"]').offset();
        $('#availableDay').css('left', position.left)
            .css('top', position.top - 26)
            .css('display', 'block');
    }

    /*
     * Highlight the start of the holiday in the calendar and show start date of the holiday.
     */
    function updateStartAt(startAt) {
        resortDefaultReservationButton();

        //Onderste 2 regels zijn destijds toegevoegd, omdat er iets kapot ging op mobiel. We hebben ze nu weer uit gezet omdat, anders de navigatie over meerdere jaren niet werkte.
        // let currentMonth = (new Date()).getMonth();
        // month = (new Date(startDate)).getMonth() - currentMonth + 1;

        $('#reservedDay').css('display', 'none');
        $('#availableDay').css('display', 'none');

        $('.no-arrivals').css('display', 'none');

        $('.day').not('.day.start-day[data-date="' + widgetApp.startAt + '"]').addClass('deselected');
        $('.day[data-date="' + startAt + '"]').addClass('selection selection_start');

        $('#holidayStartAt').html(getDayOfWeek(startAt) + ' ' + startAt);

        var minNights = $('.day.start-day[data-date="' + widgetApp.startAt + '"]').attr('data-min_nights');
        $('#minNights span').html(minNights);

        var position = $('.day.start-day[data-date="' + widgetApp.startAt + '"]').offset();
        $('#minNights').css('left', position.left)
            .css('top', position.top - 26)
            .css('display', 'block');

        $('#startAt').val(widgetApp.startAt);
        $('#startAt').removeClass('inputSelected');
        $('#endAt').addClass('inputSelected');

        // Disable book button and hide pricing.
        $('.price, .discount').css('display', 'none');
        $('#price-per-person').html('');
        $('.book-button').addClass('disabled');
        $('.book-button').html('Kies een vertrekdag');
        $('.option-button').attr('href', '#this');

        // Change legend text.
        $('#legend-available-start-day').siblings('span').html($('input[name="Possible departure day"]').val());
        $('#legend-available-no-start-end').siblings('span').html($('input[name="Available, only no possible departure day"]').val());

        $.post(apiEndpoint + '/accommodations/' + accommodationNumber + '/slots', {
            _method: 'POST',
            start_at: widgetApp.startAt,
            adults: $('#guests_adult').val(),
            youngsters: $('#guests_young').val(),
            children: $('#guests_child').val(),
            babies: $('#guests_baby').val()
        }).done(function (result) {
            $(window).trigger('va-widget.startAt.change', [result]);

            $(result).each(function (index, value) {
                if (index == 0) {
                    var departureDayCount = $('.day[data-date="' + widgetApp.startAt + '"]').attr('data-day_count');
                    if (!isNaN(departureDayCount)) {
                        var firstArrivalDayCount = $('.day[data-date="' + value + '"]').attr('data-day_count');
                        if (!isNaN(firstArrivalDayCount)) {
                            $('#minNights span').html((firstArrivalDayCount - departureDayCount));
                        }
                    }
                }
                $('.day[data-date="' + value + '"]').addClass('end-day');
            })

            var startDay = $('.day.selection_start');
            var lastEndDay = $('.day.end-day').last();

            if (parseInt(lastEndDay.attr('data-day_count')) > parseInt(startDay.attr('data-day_count'))) {
                for (var dayCount = parseInt(startDay.attr('data-day_count')); dayCount <= parseInt(lastEndDay.attr('data-day_count')); dayCount++) {
                    $('.day[data-day_count="' + dayCount + '"]').removeClass('deselected');
                    $('.day[data-day_count="' + dayCount + '"]').addClass('stayable');
                }
            }

            $('#widget').removeClass('calendar-left').addClass('calendar-right');

            let preselectedClick = widgetApp.days.filter('.preselectedClick');
            if (preselectedClick.length) {
                let endAt = widgetApp.days.filter('[data-date="' + formatDateVanilla(preselectedEndAt) + '"]')
                    .first();
                widgetApp.hoverDay(endAt);
                endAt.click();
                preselectedClick.removeClass('preselectedClick');
            }
        });
    }

    /*
     * Highlight the end of the holiday in the calendar and show end date of the holiday.
     */
    function updateEndAt(endAt) {
        $('.no-arrivals').css('display', 'block');

        $('#minNights').css('display', 'none');

        $('#reservedDay').css('display', 'none');

        $('#availableDay').css('display', 'none');

        $('.day').removeClass('stayable');
        $('.day.selection').addClass('selected');

        $('.day[data-date="' + endAt + '"]').addClass('selection selection_end');
        $('#holidayEndAt').html(getDayOfWeek(endAt) + ' ' + endAt);

        $('#endAt').val(widgetApp.endAt);
        $('#startAt, #endAt').removeClass('inputSelected');

        // Change legend text.
        $('#legend-available-start-day').siblings('span').html($('input[name="Possible arriving day"]').val());
        $('#legend-available-no-start-end').siblings('span').html($('input[name="Available, only no possible arrival day"]').val());
    }

    function resetDates() {
        $('#startAt,#endAt').val('');
        $('.time-label').remove();
        widgetApp.startAt = null;
        widgetApp.endAt = null;
        let datesSection = $('section.dates');

        if (!datesSection.parent().hasClass('only-calendar') && datesSection.css('display') === 'block') {
            $('section.calendars').css('display', 'none');
            $('section.legend').css('display', 'none');

            // Provide website with feedback about the current height.
            messageWidgetHeight();
        }

        resortDefaultReservationButton();
        widgetApp.cancelSelection();
    }

    /*
     |--------------------------------------------------------------------------
     | App initialization
     |--------------------------------------------------------------------------
     */
    $('[data-toggle="tooltip"]').tooltip();

    $('#changeGuests').click(function () {
        $('#guestsSelect').css('display', 'block');
    });

    $('body').on('click', '.day.deselected', function (e) {
        resetDates();
    });

    $('body').on('click', '.calendar-month, .legend', function (e) {
        $('#reservedDay').css('display', 'none');
        $('#availableDay').css('display', 'none');
        if (widgetApp.startAt != null && widgetApp.endAt == null) {
            resetDates();
        }
    });

    $('body').on('click', '.col-day, .nav-month-btn', function (e) {
        e.stopPropagation();
    });

    $('.reset-dates').click(function (e) {
        e.preventDefault();
        resetDates();
    });

    updateCalendars(1);

    widgetApp.changeAmountOfGuests(adults, youngsters, children, babies);

    $('#closeGuests').click(function () {
        $('#guestsSelect').hide();
    });

    $('#guestsTotal').click(function () {
        if ($('#guestsSelect').css('display') == 'none') {
            $('#guestsSelect').css('left', $('#guestsTotal').offset().left);
            $('#guestsSelect').show();
        } else {
            $('#guestsSelect').hide();
        }
    });

    $('#guestsSelect select').change(function () {
        updateGuestsString(this)
    });

    function updateGuestsString(currentElem) {
        // Check if new value does not exceed the maximum amount of guests.
        if (maxGuests < (parseInt($('#guests_adult').val()) + parseInt($('#guests_young').val()) + parseInt($('#guests_child').val()))) {
            var remaining = maxGuests - ((parseInt($('#guests_adult').val()) + parseInt($('#guests_young').val()) + parseInt($('#guests_child').val())) - parseInt($(currentElem).val()));
            $(currentElem).val(remaining);
            alert(widgetI18n('guest-selected-max'));
        }

        widgetApp.changeAmountOfGuests($('#guests_adult').val(), $('#guests_young').val(), $('#guests_child').val(), $('#guests_baby').val());
        updateGuestsAmount();
        widgetApp.trigger('guests.change')
    }

    /*
     |--------------------------------------------------------------------------
     | Helper functions
     |--------------------------------------------------------------------------
     */
    function messageWidgetHeight() {
        setTimeout(() => {
            try {
                window.parent.postMessage($('.widget').height(), "*")
            } catch (err) {
            }
        }, 0);
        setTimeout(() => {
            try {
                window.parent.postMessage($('.widget').height(), "*")
            } catch (err) {
            }
        }, 250);
    }

    function getGuestsTotal() {
        var guestsTotal = 0;

        $('#guestsSelect select').each(function (select) {
            guestsTotal += parseInt($(this).val());
        });

        return guestsTotal;
    }

    function formatMoney(price, ceil = true) {
        var formatted = '';

        if (showValuta)
            formatted += '&euro; ';

        if (ceil)
            formatted += Math.ceil(parseFloat(price)).toFixed(0) + ',-';
        else if (Math.ceil(price.toFixed(2)) == price.toFixed(2))
            formatted += parseFloat(price).toFixed(0) + ', -';
        else
            formatted += price.toFixed(2);

        return formatted.replace('.', ',');
    }

    /*
     |--------------------------------------------------------------------------
     | Mobile support
     |--------------------------------------------------------------------------
     */
    $('#startAt').focus(function () {
        if ($(this).val() !== '') {
            $('#startAt,#endAt').val('');
            $('.time-label').remove();
            widgetApp.cancelSelection();
        }

        $(this).addClass('inputSelected');
        $('#endAt').removeClass('inputSelected');
        $('#widget').removeClass('calendar-right').addClass('calendar-left');
        $('section.calendars').css('display', 'flex');
        updateCalendars(month);
    });

    $('#endAt').focus(function () {
        if ($('#startAt').val() == '' || $('#endAt').val() != '') {
            alert(widgetI18n('choose-arrival') + '.');
            $('#startAt').focus();
            $('#widget').removeClass('calendar-right').addClass('calendar-left');
            return;
        }

        $(this).addClass('inputSelected');
        $('#widget').removeClass('calendar-left').addClass('calendar-right');
        $('#startAt').removeClass('inputSelected');
        $('section.calendars').css('display', 'flex');
        updateCalendars(month);
    });

    /*
     * When a user tries to click on the book button while the button is disabled and the text in the
     * button is "Selecteer een aankomstdag", open the start at select calendar (on mobile only).
     */
    if ($(document).width() < 480) {
        $('#book-price').click(function () {
            if ($(this).children('.book-button').html() == widgetI18n('choose-arrival')) {
                $('#startAt').focus();
            }
        });
    }

    /*
     * When the link "Optie plaatsen" currently has no URL but #this, it's a sign there was
     * not yet selected a holiday. In this case it shows an alert.
     */
    $('#takeOption').click(function (e) {
        if ($(this).attr('href') == '#this') {
            e.preventDefault();
            alert(widgetI18n('choose-date-before-option'));
            return;
        }
    });

    updateCalendars(month);

    // Standard hide calendar on mobile
    if ($(document).width() < 480) {
        if ($('.widget.calendar').length === 0) {
            $('section.calendars').css('display', 'none');
            $('section.legend').css('display', 'none');
        } else {
            $('section.dates').css('display', 'none');
            $('section.legend').css('padding-left', '10px');
            updateCalendars(1);
        }
    }

    // Resize calendars on window resize.
    window.onresize = function (e) {
        if (viewportWidth !== e.target.outerWidth) {
            viewportWidth = e.target.outerWidth;
            updateCalendars(month);
        }
    };

    setTimeout(() => {
        $('.stayable').removeClass('stayable')
    }, 0);
});
